import { AnimatePresence, motion } from 'motion/react'
import {
  type PropsWithChildren,
  type ReactElement,
  useCallback,
  useEffect
} from 'react'
import { Overlay } from '../Overlay/Overlay'
import { container, position } from './Modal.css'

export type modalProps = PropsWithChildren<{
  open: boolean
  onClose: () => void
  customPositionClass?: string
}>

export const Modal = ({
  open,
  onClose,
  customPositionClass,
  children
}: modalProps): ReactElement => {
  const handleGlobalShortCut = useCallback(
    (e: KeyboardEvent): void => {
      if (e.key === 'Escape') {
        onClose()
      }
    },
    [onClose]
  )
  useEffect(() => {
    window.addEventListener('keydown', handleGlobalShortCut)
    return (): void => {
      window.removeEventListener('keydown', handleGlobalShortCut)
    }
  })
  const onModaleClose = useCallback(() => {
    // Check if there are any modals still open
    const legacyModalsOpen =
      document.querySelectorAll(
        '.modal_box__wrapper:not([style*="display: none"])'
      ).length > 0

    if (!legacyModalsOpen) {
      document.body.classList.remove('has-modale')
    }
  }, [])

  useEffect(() => {
    if (open) {
      document.body.classList.add('has-modale')
    } else {
      onModaleClose()
    }
    return () => {
      onModaleClose()
    }
  }, [open, onModaleClose])
  return (
    <AnimatePresence>
      {open && (
        <>
          <Overlay onClick={onClose} />
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className={customPositionClass ?? position}
          >
            <div className={container}>{children}</div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  )
}
